import { forceAppendQueryParams } from '../helpers/url'
import storage from '../../utils/constants/storage'

export const getLoggedUser = () => {
  const rawValue = localStorage.getItem(storage.LOGGED_USER_KEY)
  if (!rawValue || rawValue === 'undefined') return undefined
  return JSON.parse(rawValue)
}
export const getPermissions = () => {
  const rawValue = localStorage.getItem(storage.PERMISSIONS_KEY)
  if (!rawValue || rawValue === 'undefined') return undefined
  return JSON.parse(rawValue)
}
export const getWorkspace = () => {
  const rawValue = localStorage.getItem(storage.WORKSPACE_KEY)
  if (!rawValue || rawValue === 'undefined') return undefined
  return JSON.parse(rawValue)
}
export const getWorkspaceName = () => {
  const workspace = getWorkspace() || {}
  return workspace?.name || workspace
}
export const getProjectId = () => {
  const rawValue = localStorage.getItem(storage.PROJECT_ID)
  if (!rawValue || rawValue === 'undefined') return undefined
  return JSON.parse(rawValue)
}
export const getAuthToken = () => localStorage.getItem(storage.AUTH_TOKEN_KEY)

export const setLoggedUser = v => localStorage.setItem(storage.LOGGED_USER_KEY, JSON.stringify(v))
export const setPermissions = v => localStorage.setItem(storage.PERMISSIONS_KEY, JSON.stringify(v))
export const setWorkspace = v => localStorage.setItem(storage.WORKSPACE_KEY, JSON.stringify(v))
export const setAuthToken = v => localStorage.setItem(storage.AUTH_TOKEN_KEY, v)
export const setProjectId = v => localStorage.setItem(storage.PROJECT_ID, v)

export const clearLoggedUser = v => localStorage.removeItem(storage.LOGGED_USER_KEY)
export const clearWorkspace = v => localStorage.removeItem(storage.WORKSPACE_KEY)
export const clearAuthToken = v => localStorage.removeItem(storage.AUTH_TOKEN_KEY)
export const clearPermissions = v => localStorage.removeItem(storage.PERMISSIONS_KEY)
export const clearProjectId = v => localStorage.removeItem(storage.PROJECT_ID)

export const initSessionVars = ({ user, token, workspace, permissions, projectId }) => {
  setLoggedUser(user)
  setWorkspace(workspace)
  setAuthToken(token)
  setPermissions(permissions)
  if (projectId) setProjectId(projectId)
}

export const destroySessionVars = () => {
  clearLoggedUser()
  clearWorkspace()
  clearAuthToken()
  clearPermissions()
  clearProjectId()
}

export const handle401 = () => {
  destroySessionVars()
  forceAppendQueryParams('reason', 401)
}

export const getSessionVars = () => {
  const user = getLoggedUser()
  const workspace = getWorkspace()
  const token = getAuthToken()
  const permissions = getPermissions()
  const projectId = getProjectId()
  return { user, workspace, token, permissions, projectId }
}
